import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=196ccbae&scoped=true"
import script from "./clause.vue?vue&type=script&lang=js"
export * from "./clause.vue?vue&type=script&lang=js"
import style0 from "./clause.vue?vue&type=style&index=0&id=196ccbae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ccbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196ccbae')) {
      api.createRecord('196ccbae', component.options)
    } else {
      api.reload('196ccbae', component.options)
    }
    module.hot.accept("./clause.vue?vue&type=template&id=196ccbae&scoped=true", function () {
      api.rerender('196ccbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/clause.vue"
export default component.exports